export default "__VITE_ASSET__a94470e7__"